import { Controller } from "@hotwired/stimulus"

// data-controller="date-range"
export default class extends Controller {
  static targets = ["start", "end", "error", "button"]

  connect() {
    this.validate() // Validar al cargar
  }

  validate() {
    const startVal = this.startTarget.value
    const endVal   = this.endTarget.value
    const minDate  = new Date("1990-01-01")
    const maxDate  = new Date() // hoy

    this.errorTarget.textContent = ""
    let valid = true // <-- inicializamos valid

    if (startVal) {
      const startDate = new Date(startVal)
      if (startDate < minDate) {
        this.errorTarget.textContent = "La fecha desde no puede ser anterior al 01/01/1990."
        valid = false
      }
    }

    if (endVal) {
      const endDate = new Date(endVal)
      if (endDate > maxDate) {
        this.errorTarget.textContent = "La fecha hasta no puede ser futura."
        valid = false
      }
    }

    if (startVal && endVal) {
      const startDate = new Date(startVal)
      const endDate   = new Date(endVal)
      if (startDate > endDate) {
        this.errorTarget.textContent = "La fecha desde no puede ser posterior a la fecha hasta."
        valid = false
      }
    }
    
    // Deshabilitar o habilitar botón según valid
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = !valid
      this.buttonTarget.classList.toggle("disabled", !valid)
    }
  }
}
